import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-demo-screen-dialog',
  templateUrl: './demo-screen-dialog.component.html',
  styleUrls: ['./demo-screen-dialog.component.scss']
})
export class DemoScreenDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DemoScreenDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onUpgrade(): void {
    this.dialogRef.close(true);
  }

}
